import { VirtualBrand } from '~/Api/Analytics/Autocomplete/VirtualBrand';

import ActionTypes from './ActionTypes';

export interface BrandsState {
	request: Promise<any>;
	isFetching: boolean;
	items: VirtualBrand[] | null;
}

export interface State {
	byFilter: { [key: string]: BrandsState };
}

type Action =
	| {
			type: ActionTypes.request;
			request: Promise<any>;
			filter: string;
	  }
	| {
			type: ActionTypes.receive;
			request: Promise<any>;
			filter: string;
			items: VirtualBrand[] | null;
	  };

function createState(): State {
	return { byFilter: {} };
}

export default function reducer(state: State = createState(), action: Action) {
	switch (action.type) {
		case ActionTypes.request:
			return {
				...state,
				byFilter: {
					...state.byFilter,
					[action.filter]: {
						request: action.request,
						isFetching: true,
						items: [],
					},
				},
			};

		case ActionTypes.receive: {
			const brandsState = state.byFilter[action.filter];
			if (brandsState?.request !== action.request) {
				return state;
			}
			if (!action.items) {
				const byFilter = { ...state.byFilter };
				delete byFilter[action.filter];
				return { ...state, byFilter };
			}

			return {
				...state,
				byFilter: {
					...state.byFilter,
					[action.filter]: {
						...brandsState,
						isFetching: false,
						items: action.items,
					},
				},
			};
		}

		default:
			return state;
	}
}

export function selectBrands(state: State, filter: string): BrandsState | null {
	return state.byFilter[filter.slice(0, 1)] || null;
}
